import React from "react";
import "./Header.scss";

export const Header = ({ title, subHeader }) => {
  return (
    <div className="header-alif">
      <div className="row">
        <div className="col">
          <div className="page-title">
            {title ? title : "Загрузите документы"}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className="page-description">
            {subHeader
              ? subHeader
              : "Загрузите необходимые документы для дальнейшего рассмотрения вашей заявки."}
          </div>
        </div>
      </div>
    </div>
  );
};
